import React, { useState, useEffect, useRef } from 'react';
import { useCurrency } from '../context/CurrencyContext';

const CurrencySwitcher = ({ onToggle, isOtherOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { currency: selectedCurrency, updateCurrency } = useCurrency();
  const dropdownRef = useRef(null);

  const currencies = [
    {
      code: 'USD',
      name: 'USD',
      flag: 'https://flagcdn.com/w40/us.png',
      symbol: '$',
    },
    {
      code: 'EUR',
      name: 'EUR',
      flag: 'https://flagcdn.com/w40/eu.png',
      symbol: '€',
    },
    {
      code: 'AED',
      name: 'AED',
      flag: 'https://flagcdn.com/w40/ae.png',
      symbol: 'Ð',
    },
    {
      code: 'KZT',
      name: 'KZT',
      flag: 'https://flagcdn.com/w40/kz.png',
      symbol: '₸',
    },
  ];

  const handleCurrencyChange = (currencyCode) => {
    updateCurrency(currencyCode);
    setIsOpen(false);
  };

  const handleToggle = () => {
    const newState = !isOpen;
    setIsOpen(newState);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const currentCurrency =
    currencies.find((currency) => currency.code === selectedCurrency) ||
    currencies[0];

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={handleToggle}
        className="flex items-center gap-1 bg-[#F5F5F5] rounded-full pl-1 pr-2 py-1 transition duration-200"
      >
        <img
          src={currentCurrency.flag}
          alt={`${currentCurrency.name} flag`}
          className="w-6 h-6 object-cover rounded-full"
        />
        <span className="text-[14px] leading-[16px] font-medium text-black">
          {currentCurrency.name}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 bottom-full mb-2 md:bottom-auto md:top-full md:mt-2 w-40 bg-white rounded-lg shadow-lg border border-gray-200 z-50 md:right-0 right-auto left-0">
          <div className="py-2">
            {currencies.map((currency) => (
              <button
                key={currency.code}
                onClick={() => handleCurrencyChange(currency.code)}
                className={`w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-100 transition duration-200 ${selectedCurrency === currency.code
                  ? 'bg-gray-50 text-black'
                  : 'text-gray-700'
                  }`}
              >
                <img
                  src={currency.flag}
                  alt={`${currency.name} flag`}
                  className="w-6 h-6 object-cover rounded-full"
                />
                <span className="text-sm font-medium">{currency.name}</span>
                <span className="text-xs text-gray-500 ml-auto">
                  {currency.symbol}
                </span>
                {selectedCurrency === currency.code && (
                  <svg
                    className="w-3 h-3 ml-1 text-black"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySwitcher;
